import cn from 'classnames';
import moment from 'moment';
import Marquee from 'react-fast-marquee';

import { Button } from '@sravni/react-design-system/lib/Button';
import { Logo } from '@sravni/react-design-system/lib/Logo';
import { Space } from '@sravni/react-design-system/lib/Space';
import { Text } from '@sravni/react-design-system/lib/Typography';
import { useIsMobile } from '@sravni/react-utils';

import { Image } from '@/components/Image';
import { mask } from '@/utils/mask';

import { CONTACT_PHONE, CONTACT_EMAIL } from '../../../constants/contacts';

import { MARQUEE_IMGS } from './constants';
import MailImage from './imgs/social/Mail';
import styles from './styles.module.scss';

export const Footer = () => {
  const isMobile = useIsMobile();

  const currentYear = moment().year();

  return (
    <footer>
      <Marquee gradient={false} className={cn(styles.marquee, 'h-pt-20 h-pb-20')}>
        {MARQUEE_IMGS.map((el, idx) => (
          // eslint-disable-next-line react/no-array-index-key
          <Image className={styles.marquee_img} key={idx} {...el} />
        ))}
      </Marquee>
      <div className={styles.footer}>
        <Logo className={styles.logo} />
        <div className={styles.info}>
          <div className={styles['left-side']}>
            <Text size={12} className={styles.coop}>
              © 2009–{currentYear}, ООО «Сравни.ру». При использовании материалов гиперссылка на sravni.ru обязательна.
              ИНН 7710718303, ОГРН 1087746642774. 109544, г. Москва, бульвар Энтузиастов, дом 2, 26 этаж.{' '}
            </Text>
            <Text size={12} className={styles.cookie}>
              Мы используем файлы cookie для того, чтобы предоставить пользователям больше возможностей при посещении
              сайта sravni.ru. Подробнее об условиях использования.
            </Text>
          </div>
          <div className={styles['right-side']}>
            {!isMobile && <Text size={14}>Служба заботы о клиентах</Text>}

            <Text className={styles.number}>{mask(CONTACT_PHONE, '# ### ### ## ##')}</Text>

            <Text className={styles['work-time']}>Ежедневно с 9:00 до 21:00 по МСК</Text>

            {isMobile && <Text size={14}>Служба заботы о клиентах</Text>}
            <Space size={8} className={styles.social}>
              <a href={`mailto:${CONTACT_EMAIL}`}>
                <Button className={styles.social_button}>
                  <MailImage />
                </Button>
              </a>
            </Space>
          </div>
        </div>
      </div>
    </footer>
  );
};
